module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 0
// module chunks = 138